import moment from "moment/moment";
import htmlToText from "html-to-text";

export default {
    MakePDF(prog, spo_control, spo_times, o_lectureTime, o_practiceTime, o_laboratoryTime, o_ikrTime, o_ktoTime, o_keTime, o_lessonTime, o_seminarTime,
            o_controlTime, o_indepTime, o_lectures, o_lesson, o_seminar, o_practice, o_laboratory, o_indepWork, o_themes) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        }
        moment.locale('ru');
        const htmlToText = require('html-to-text');
        let special = "Специальность"
        let control = ""
        let control_spo = ""
        let prac = `Из общего объема часов ${ (parseFloat(o_practiceTime) + parseFloat(o_laboratoryTime)).toFixed(2) } часов являются практической подготовкой, которая представлена в программе в виде практических занятий`
        let approval_date = moment(prog.updated_at).format('LL')
        let comp_text = prog.spo_comp.general
        let department = []
        let disciplines = `дисциплины`
        let disciplines_main = 'Дисциплина'
        let provisor = prog.main_info.provisor
        if (prog.main_info.discipline_type === 'Общеобразовательная дисциплина' ){
            disciplines = 'учебного предмета'
            provisor = 'Богодухова Екатерина Евгеньевна'
            prac = ''
        }
        else if (prog.main_info.discipline_type === 'МДК') {
            disciplines = 'МДК'
            disciplines_main = 'МДК'
        }
        else if (prog.main_info.discipline_type === 'Профессиональный модуль' ) {
            disciplines = 'профессионального модуля'
            disciplines_main = 'Профессиональный модуль'
        }
        if (prog.main_info.department !== null){
            department = prog.main_info.department.split(' ').slice(1);
        }
        if (prog.main_info.dep_manager === null){
            prog.main_info.dep_manager = ""
        }
        if (spo_times["Семестровый контроль"].period.length){
            control += `Семестровый контроль ${spo_times["Семестровый контроль"].period.join()} сем      \n`
            control_spo += `${spo_times["Семестровый контроль"].period.join()} семестр семестровый контроль \n`
        }
        if (prog.main_info.exam.length){
            control += `Экзамен   ${ getPeriod(prog.main_info.exam) } сем      \n`
            control_spo += `${ getPeriod(prog.main_info.exam) } семестр экзамен \n`
        }
        if (prog.main_info.credit.length){
            control += `Зачет    ${ getPeriod(prog.main_info.credit) } сем      \n`
            control_spo += `${ getPeriod(prog.main_info.credit) } семестр зачет \n`
        }
        if (prog.main_info.credit_mark.length){
            control += `Зачет с оценкой    ${ getPeriod(prog.main_info.credit_mark) } сем      \n`
            control_spo += `${ getPeriod(prog.main_info.credit_mark) } семестр зачет с оценкой \n`
        }
        if (spo_times["Другие формы контроля"].period.length){
            control += `Другие формы контроля    ${spo_control.period.join()} сем      \n`
            control_spo += `${spo_times["Другие формы контроля"].period.join()} семестр другие формы контроля \n`
        }
        if (spo_times["Курсовой проект"].period.length){
            control += `Курсовой проект    ${spo_times["Курсовой проект"].period.join()} сем      \n`
            control_spo += `${spo_times["Курсовой проект"].period.join()} семестр курсовой проект \n`
        }
        if (spo_times["Курсовая работа"].period.length){
            control += `Курсовая работа   ${spo_times["Курсовая работа"].period.join()} сем      \n`
            control_spo += `${spo_times["Курсовая работа"].period.join()} семестр курсовая работа \n`
        }
        if (prog.main_info.creator.title === null){
            prog.main_info.creator.title = ""
        }
        let n = 0
        let n_comp = 0
        let n_content = 0

        function num(){
            n = n+1
            return n
        }
        function getInitial(fio){
            let initial = ""
            if (fio !== ""){
                fio = fio.replaceAll("  ", " ")
                fio = fio.trim();
                initial += fio.split(' ')[1][0];
                initial +="."
                initial += fio.split(' ')[2][0];
                initial +=". "
                initial += fio.split(' ')[0];
            }
            return initial
        }
        function getPeriod(period){
            if (typeof period === "string"){
                return period
            }
            if (typeof period === "object"){
                return period.join()
            }
        }
        function buildTitle() {
            var body = [];
            var discipline = `по дисциплине`
            if (prog.main_info.discipline_type === 'Общеобразовательная дисциплина'){
                discipline = 'учебный предмет'
            }
            else if (prog.main_info.discipline_type === 'МДК') {
                discipline = 'МДК'
            }
            else if (prog.main_info.discipline_type === 'Профессиональный модуль') {
                discipline = 'профессиональный модуль'
            }
            body.push(
                [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                [{text: 'РАБОЧАЯ ПРОГРАММА', alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${discipline}`, alignment: 'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `${prog.main_info.disciplines_index.toUpperCase()} ${prog.name}`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                [{text: `${special} ${prog.main_info.speciality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Квалификация выпускника – ${prog.main_info.quality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                [{text: `Год набора – ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
            )
            return body;
        }
        function buildControl() {
            var body = [];
            body.push(
                [{text: control, style: 'twelveNormalControl', border: [false, false, false, false]}],
                [{text: `Общая трудоемкость ${disciplines} ${prog.main_info.load.hour} (академ. час)`, style: 'twelveNormal', border: [false, false, false, false]}],
            )
            return body;
        }
        function buildApproval() {
            var body = [];
            body.push(
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: `Зам. декана по учебной работе`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Председатель ЦМК`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: `Кирилюк`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `Н.В. Кирилюк`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `${(prog.main_info.provisor.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `${getInitial(prog.main_info.provisor)}`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                [{text: `«  2 »     марта           ${prog.main_info.year} г.`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `«  2 »     марта            ${prog.main_info.year} г.`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Центр цифровой трансформации и технического обеспечения`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `А.А. Тодосейчук`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                [{text: `«  2 »     марта            ${prog.main_info.year} г.`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `«  2 »     марта            ${prog.main_info.year} г.`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],)
            return body;
        }
        function buildForms(){
            let body = [];
            if (prog.spo_comp.business === true){
                body.push(
                    [{text: `\t\t• Деловые игры`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}]
                )
            }
            if (prog.spo_comp.role === true){
                body.push(
                    [{text: `\t\t• Ролевые игры`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}]
                )
            }
            if (prog.spo_comp.situation === true){
                body.push(
                    [{text: `\t\t• Разбор ситуаций`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}]
                )
            }
            if (prog.spo_comp.computer === true){
                body.push(
                    [{text: `\t\t• Компьютерные симуляции`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}]
                )
            }
            body.push([{text: ``, style: 'twelveBold', alignment: 'justify', border: [false, false, false, false]}])
            return body;
        }
        function buildTheme(){
            var body = [];
            body.push(
                [{text: `\t   ${num()}. ТЕМАТИЧЕКСИЙ ПЛАН ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `Общая трудоемкость ${disciplines} составляет ${prog.main_info.load.zet} зачетных единицы, ${prog.main_info.load.hour} академических часов. `, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `1 – № п/п`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `2 – Тема (раздел) ${disciplines}, курсовая работа (проект), промежуточная аттестация`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `3 – Семестр`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4 – Виды контактной работы и трудоемкость (в академических часах)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.1 – Л (Лекции)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.2 – ПЗ (Практические занятия)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.3 – ЛЗ (Лабораторные занятия)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.4 – Курсовой проект/работа`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.5 – КТО`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.6 – Консультации`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.7 – У (Уроки)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `4.8 – С (Семинарские занятия)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `5 – Экзамен`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `6 – Самостоятельные занятия (в академических часах)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                [{text: `7 – Формы текущего контроля успеваемости`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
            )
            return body;
        }
        function buildTableThemeSPO(data, columns) {
            var body = [];
            body.push(
                [{
                    text: '1', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: '2', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: '3', style: 'twelveNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: '4', style: 'tenNormal', alignment: 'center', colSpan: 8, border: [true, true, true, true]
                }, {}, {}, {}, {}, {}, {}, {}, {
                    text: '5', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: '6', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: '7', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true] }],
                [{},{},{},{text: `4.1`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.2`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.3`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.4`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.5`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.6`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.7`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.8`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {}, {}, {}],
            )
            data.forEach(function(row) {
                var dataRow = [];

                columns.forEach(function(column) {
                    dataRow.push(
                        {text: row[column].toString(), style: 'tenNormal'})
                });
                body.push(dataRow);
            });
            body.push([{},{text: `Итого`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]},{},{text: `${o_lectureTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_practiceTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_laboratoryTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_lessonTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_seminarTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_ikrTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_ktoTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_keTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_controlTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_indepTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {}])

            return body;
        }
        function buildComp(){
            var body = [];
            body.push([{text: `\t   ${num()}. ПЛАНИРУЕМЫЕ РЕЗУЛЬТАТЫ ОСВОЕНИЯ ${disciplines.toUpperCase()}`, style: 'twelveBold', alignment: 'justify', colSpan: 4, border: [false, false, false, false]},{},{},{}])
            if (prog.main_info.discipline_type !== 'Общеобразовательная дисциплина'){
                body.push([{text: `Программа предназначена для подготовки к формированию компетенций`, style: 'twelveNormal', alignment: 'justify', colSpan: 4, border: [false, false, false, false]},{},{},{}])
            }
            return body;
        }
        function buildCompetitionCat() {
            var body = [];
            if (prog.competition.UK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `${n}.${n_comp}. Общие компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `Категория (группа) общих компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование общих компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Минимальные требования`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.competition.UK.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.OPK_cat.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `${n}.${n_comp}. Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `Категория (группа) профессиональных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование профессиональных компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Минимальные требования`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.competition.OPK_cat.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildCompetition() {
            var body = [];
            if (prog.competition.OPK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.OPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.PK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.PK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.DPK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Дополнительные профессиональные компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование дополнительной профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения дополнительной профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.DPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildSPOComp(){
            var body = [];
            if (prog.spo_comp.able.length || prog.spo_comp.know.length || prog.spo_comp.own.length){
                body.push([{text: `В результате изучения ${disciplines} обучающийся должен:`, style: 'twelveBold', alignment: 'justify', border: [false, false, false, false]}])
            }
            if (prog.spo_comp.able.length){
                body.push([{text: `\t\t Уметь`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}])
                body.push([{text: htmlToText.fromString(prog.spo_comp.able, {
                        wordwrap: 10000,
                        tags: {
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }), style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}])
            }
            if (prog.spo_comp.know.length){
                body.push([{text: `\t\t Знать`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}])
                body.push([{text: htmlToText.fromString(prog.spo_comp.know, {
                        wordwrap: 10000,
                        tags: {
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }), style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}])
            }
            if (prog.spo_comp.own.length){
                body.push([{text: `\t\t Иметь практический опыт`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}])
                body.push([{text: htmlToText.fromString(prog.spo_comp.own, {
                        wordwrap: 10000,
                        tags: {
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }), style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}])
            }
            body.push([{text: ``, style: 'twelveBold', alignment: 'justify', border: [false, false, false, false]}])
            return body;
        }
        function buildLectures() {
            var body = [];
            if (o_lectures.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Лекции`, style: "twelveBold", alignment: 'justify', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `№ п/п`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_lectures.forEach(function(lec) {
                    body.push([{text: `${o_lectures.indexOf(lec) + 1}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${lec.lecture_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(lec.lec_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }

        function buildLessons() {
            var body = [];
            if (o_lesson.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Уроки`, style: "twelveBold", alignment: 'justify', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `№ п/п`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_lesson.forEach(function(les) {
                    body.push([{text: `${o_lesson.indexOf(les) + 1}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${les.lesson_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(les.les_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }

        function buildSeminar() {
            var body = [];
            if (o_seminar.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Семинарские занятия`, style: "twelveBold", alignment: 'justify', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `№ п/п`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_seminar.forEach(function(sem) {
                    body.push([{text: `${o_seminar.indexOf(sem) + 1}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${sem.seminar_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(sem.sem_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }
        function buildPractice() {
            var body = [];
            if (o_practice.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Практические занятия`, style: "twelveBold", alignment: 'justify', colSpan: 2, border: [false, false, false, false]},{}])
                body.push([{text: `Наименование темы`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Содержание темы`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_practice.forEach(function(prac) {
                    prac.practice_work.forEach(function(work) {
                        body.push([{text: `${work.work_name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: htmlToText.fromString(work.content, {
                                wordwrap: 10000,
                                tags: {
                                    'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                    'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                                },
                            }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                    });
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }
            return body;
        }
        function buildLaboratory() {
            var body = [];
            if (o_laboratory.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Лабораторные занятия`, style: "twelveBold", alignment: 'justify', colSpan: 2, border: [false, false, false, false]},{}])
                body.push([{text: `Наименование темы`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Содержание темы`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_laboratory.forEach(function(lab) {
                    lab.laboratory_work.forEach(function(work) {
                        body.push([{text: `${work.work_name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: htmlToText.fromString(work.content, {
                                wordwrap: 10000,
                                tags: {
                                    'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                    'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                                },
                            }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                    });
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildIndep() {
            var body = [];
            if (o_indepWork.length){
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `${num()}. САМОСТОЯТЕЛЬНАЯ РАБОТА`, style: 'twelveBold', alignment: 'justify', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `№ п/п`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Трудоемкость в академических часах`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_indepWork.forEach(function(work) {
                    body.push([{text: `${o_indepWork.indexOf(work) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${work.indep_work_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(work.indep_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]},{text: `${work.indep_work}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }
        function buildEvalTool(){
            var body = [];
            body.push([{text: `Результаты (освоенные профессиональные компетенции)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Формы и методы контроля и оценки`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
            if (prog.spo_controls.length){
                prog.spo_controls.forEach(function(control) {
                    body.push([{text: `${control.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${control.lec}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [false, false, false, false]},{}])
            }
            else{
                if (prog.competition.UK.length){
                    prog.competition.UK.forEach(function(control) {
                        body.push([{text: `${control.info.cat} ${control.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${control.control}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]}]);
                    });
                }
                if (prog.competition.OPK_cat.length){
                    prog.competition.OPK_cat.forEach(function(control) {
                        body.push([{text: `${control.info.cat} ${control.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${control.control}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]}]);
                    });
                }
                body.push([{text: ``, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [false, false, false, false]},{}])
            }

            return body;
        }
        function buildSoftware() {
            var body = [];
            let n_soft = 0
            if (prog.software.length || prog.resources.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.software.forEach(function(soft) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.license}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                prog.resources.forEach(function(res) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }
        function buildDataBases() {
            var body = [];
            if (prog.data_bases.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.data_bases.forEach(function(db) {
                    body.push([{text: `${prog.data_bases.indexOf(db) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }
        let titlePage = {
            info: {
                title: `Рабочая программа ${disciplines} ${prog.main_info.discipline} ${prog.main_info.speciality} ${prog.main_info.year}`,
                author: 'ЦЦТиТО, АмГУ',
                subject: '',
                keywords: ''
            },
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins:[60,40,60,60],

            header:[],
            footer:[],
            content: [
                {
                    text: 'Министерство науки и высшего образования Российской Федерации \n Федеральное государственное бюджетное образовательное учреждение \n высшего образования \n "Амурский государственный университет"',
                    style: "twelveNormal", alignment: 'center',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [240,110,100],
                        heights: [8,'auto','auto','auto'],
                        body: [
                            [{text: '', style: 'eightNormal', colSpan: 3, border: [false, false, false, false]}, {},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'УТВЕРЖДАЮ', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Проректор по учебной и научной работе', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Лейфа', alignment:'center', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{text:'А.В. Лейфа', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${approval_date}`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [50,'auto','auto',30],
                        body: buildTitle()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [520],
                        heights: [10],
                        body: buildControl()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [50,'auto','auto'],
                        body: [
                            [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                            [{text: `Составитель ${getInitial(prog.main_info.creator.fio)}, ${prog.main_info.creator.position}, ${prog.main_info.creator.title.replaceAll("ученая степень отсутствует", "")}`, style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.facility}`, style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.department}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [130],
                        body: [
                            [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.year}`, pageBreak: 'after', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    text: `${prog.main_info.basis} от ${prog.main_info.basis_date} № ${prog.main_info.basis_num}`, alignment:'justify', style: 'twelveNormal',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [20,20],
                        body: [
                            [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `Рабочая программа обсуждена на заседании ЦМК ${department.join(" ")}`,  style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [100,120],
                        heights: ['auto'],
                        body: [
                            [{text: `${prog.main_info.approval_date} г.`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `, протокол № ${prog.main_info.protocol_num}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [140,80,100],
                        heights: [10],
                        body: [
                            [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: ``, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                            [{text: `Председеатель ЦМК`, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${(provisor.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [100,100,30,100,100,30],
                        heights: [100,'auto','auto',10],
                        body: buildApproval()
                    }
                },
                {
                    text: `\t\t ${num()} ПОЯСНИТЕЛЬНАЯ ЗАПИСКА`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `Рабочая программа ${prog.main_info.discipline} являетсяч частью ППССЗ в соотвествии с ФГОС по специальности ${prog.main_info.speciality}`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `${disciplines_main} требует предварительного изучения`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.purpose_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `${disciplines_main} предшествует изучению (предназначена для создания теоретической базы знаний у студентов для изучения)`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.tasks_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `${prac}`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `Воспитание реализуется в программе в единстве урочной и внеурочной деятельности. В рамках каждого занятия планируются воспитательные цели, направленные на формирование профессионала в соответствии с квалификацией ${prog.main_info.quality} и воспитание соответствующих качеств личности.`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `При планировании и проведении занятий планируются активные и интерактивные формы учебной деятельности:`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [],
                        body: buildForms()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,100,130,200],
                        heights: [],
                        body: buildComp()
                    }
                },
                {
                    text: htmlToText.fromString(comp_text, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,100,130,200],
                        heights: [],
                        body: buildCompetitionCat()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,150,290],
                        heights: [],
                        body: buildCompetition()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [],
                        body: buildSPOComp()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [],
                        body: buildTheme()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [11,80,10,20,20,20,20,20,20,20,20,20,20,60],
                        heights: [],
                        body: buildTableThemeSPO(
                            o_themes,
                            ['num','name', 'period', 'lecture', 'practice', 'laboratory', 'lesson', 'seminar', 'ikr', 'kto', 'ke', 'control', 'indep_work', 'control_form'],
                        )
                    }
                },
                {
                    text: `\t\t ${num()}. СОДЕРЖАНИЕ ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,5,150,280],
                        heights: [],
                        body: buildLectures()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,155,290],
                        heights: [],
                        body: buildPractice()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,155,290],
                        heights: [],
                        body: buildLaboratory()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,5,150,280],
                        heights: [],
                        body: buildLessons()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,5,150,280],
                        heights: [],
                        body: buildSeminar()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,120,230,85],
                        heights: [],
                        body: buildIndep()
                    }
                },
                {
                    text: `\t\t ${num()}. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [260,210],
                        heights: [],
                        body: buildEvalTool()
                    }
                },
                {
                    text: 'Форма промежуточной атестации:', style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `${control_spo}`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.eval_tool_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. УЧЕБНО-МЕТОДИЧЕСКОЕ И ИНФОРМАЦИОННОЕ ОБЕСПЕЧЕНИЕ ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `\t\t а) литература`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.literature_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags: {
                            'a': { options: {
                                    hideLinkHrefIfSameAsText: true,
                                    noLinkBrackets: true},
                            },
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }),
                    style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t б) программное обеспечение и Интернет-ресурсы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildSoftware()
                    }
                },
                {
                    text: `\t\t в) профессиональные базы данных и информационные справочные системы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildDataBases()
                    }
                },
                {
                    text: `\t\t ${num()}. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.structure_text_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify'
                },
            ],
            styles: {
                eightNormal: {
                    fontSize: 8,
                    font: 'Times',
                    bold: false
                },
                tenNormal: {
                    fontSize: 10.5,
                    font: 'Times',
                    bold: false
                },
                twelveNormal: {
                    fontSize: 12,
                    font: 'Times',
                    bold: false,
                    preserveLeadingSpaces: true
                },
                twelveNormalControl: {
                    fontSize: 12,
                    font: 'Times',
                    bold: false,
                    lineHeight: 1.5,
                },
                twelveBold: {
                    fontSize: 12,
                    font: 'Times',
                    bold: true,
                    preserveLeadingSpaces: true
                },
            }
        }
        pdfMake.createPdf(titlePage).download(`${prog.main_info.discipline} ${prog.main_info.speciality_code} ${prog.main_info.year}.pdf`);
    }
}